import { pgEnum } from 'drizzle-orm/pg-core'

/**
 * Why a document carries zero VAT. A zero rate alone says nothing about the tax treatment:
 * §19, §13b, an intra-community supply and an export all show 0 % and are booked differently,
 * carry different mandatory notes under §14 UStG, and map to different XRechnung tax categories.
 *
 * The list stays deliberately short. A longer list of paragraph numbers is a list a Handwerker
 * cannot choose from correctly, and a wrong choice here is worse than a coarse one.
 *
 * `null` is a permanent, meaningful state: "not specified". Documents issued before this field
 * existed keep it, and it preserves the pre-existing behaviour everywhere (XRechnung category
 * `Z`, no exemption reason, no PDF note).
 */
export const taxExemptionReasonEnumArray = [
  /** Kleinunternehmer, § 19 UStG — applies to the whole document. */
  'small_business',
  /** Steuerschuldnerschaft des Leistungsempfängers, § 13b UStG — Bauleistungen and other B2B reverse charge. */
  'reverse_charge',
  /** Innergemeinschaftliche Lieferung, § 4 Nr. 1b UStG. */
  'intra_community',
  /** Ausfuhrlieferung into a third country, § 4 Nr. 1a UStG. */
  'export',
  /** The remaining § 4 UStG exemptions. Requires the document's free-text note. */
  'exempt_other',
] as const

export type TaxExemptionReason = (typeof taxExemptionReasonEnumArray)[number]

export const taxExemptionReasonEnum = pgEnum('tax_exemption_reason', taxExemptionReasonEnumArray)
